import type { ReactNode } from 'react';

export type WidgetRenderer<T = unknown> = (props: T) => ReactNode;

interface WidgetRegistryInstance {
  register<T>(type: string, renderer: WidgetRenderer<T>): void;

  resolve<T>(type: string): WidgetRenderer<T> | undefined;
}

function createRegistry(): WidgetRegistryInstance {
  const map = new Map<string, WidgetRenderer>();
  return {
    register(type, renderer) {
      map.set(type, renderer as WidgetRenderer);
    },
    resolve<T>(type: string) {
      return map.get(type) as WidgetRenderer<T> | undefined;
    }
  };
}

export const widgetRegistry = createRegistry();

// Widget type keys — both contributors and the host import from here.
export const WIDGET_TYPES = {
  TABLE: 'table'
} as const;

// Shared data shape the host passes to any registered table widget renderer.
export type TableWidgetData = {
  tool_call_id: string;
  rows: Array<{
    code: string;
    title: string;
    period_type: string;
    time_ref?: number;
  }>;
  metadata?: { start_date?: string; end_date?: string };
};
